<template>
  <div class="datesHeader">
    <span>
      {{ primaryLabel }}
    </span>
    <span>
      {{ secondaryLabel }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',
  setup(props) {
    const labels = (props.params?.displayName ?? '').split(' ').filter((item) => item.length > 0);
    const primaryLabel = labels[0] ?? '';
    const secondaryLabel = labels.slice(1).join(' ');
    return {
      primaryLabel,
      secondaryLabel
    };
  }
}
</script>
  <style>
  .datesHeader {
    display: flex;
    flex-direction: column;
  }
  </style>
